exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-row[data-v-4398794f]{font-weight:600}", ""]);

// exports
